module.exports = __webpack_public_path__ + "assets/priceoff.png?dc2a4207101ff72f9747355fafcec2eb";